import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modals-confirm',
  templateUrl: './modals-confirm.component.html',
  styleUrls: ['./modals-confirm.component.css']
})
export class ModalsConfirmComponent implements OnInit {
  bodyTranslation: string
  constructor(  public dialogRef: MatDialogRef<ModalsConfirmComponent>, private translate: TranslateService){
  }
 
  Accept(){
    this.dialogRef.close(true);
  }
  Close(){
    this.dialogRef.close(false);
 
}
ngOnInit(){
  this.translate.get('terms-conditions.policy-request').subscribe((data: any) => {
    if (!(data === null || data === undefined)) {
      this.bodyTranslation = data.split('\n');
    }
  });
}
}